module.exports = function getResource(label, vars = []) {
    const resources = {
        freeSamples: 'Free Samples',
        freeSamplesCTA: `Get ${vars[0]} free sample(s) with every order`,
        samplesAddedText: ` sample${vars[0] !== 1 ? 's' : ''} added`,
        done: 'Done'
    };

    return resources[label];
};
